import { workloadConstants } from "@/constants";
import type { WorkloadUserDetailInterface } from "@/interfaces";
import { workloadService } from "@/services";

import { useQueryAction } from "../shared";

export const useWorkloadByUser = (userId: string) => {
    const { data, isLoading, refetch } = useQueryAction<WorkloadUserDetailInterface | null>(
        () => workloadService.byUserHandler(userId),
        [userId],
        {
            enabled: !!userId,
            errorFallback: workloadConstants.errors.fetchFailed,
            context: "workload.byUser",
            initialData: null,
        },
    );
    return { detail: data ?? null, isLoading, refetch };
};
